<template>
  <div id="search-box">
    <el-row >
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('refCode')}}</label>
        <el-input v-model="filter.refCode"
                  :placeholder="$t('code')"
                  size="mini"></el-input>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('agent')}}</label>
        <el-select v-model="filter.agentId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(agent, index) in sortedAgentList"
            :key="index"
            :label="agent.name"
            :value="agent.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('hotel')}}</label>
        <el-select v-model="filter.hotelId"
                   :placeholder="$t('all')"
                   size="mini"
                   @change="onHotelSelectChanged()"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(hotel, index) in sortedHotelList"
            :key="index"
            :label="hotel.name"
            :value="hotel.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('promotion')}}</label>
        <el-select v-model="filter.promotionId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(promotion, index) in preparePromotionList"
            :key="index"
            :label="promotion.code"
            :value="promotion.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="padding: 0 5px;" >
        <label class="label-form-search">{{$t('specialOfferValid')}}</label><br>
        <el-date-picker v-model="filter.specialOfferValid" style="width: 100% !important;"
                        type="date"
                        format="d MMM yyyy"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('selectDate')"
                        size="mini">
        </el-date-picker>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <el-popover
          placement="bottom"
          width="600"
          trigger="click"
          @show="visible = true"
          @hide="visible = false"
          >
          <el-row style="padding: 10px 0;">
            <el-col :span="8" style="padding: 0 5px;">
              <label class="label-form-search">{{$t('status')}}</label>
            </el-col>
            <el-col :span="12" style="padding: 0 5px;">
              <el-select v-model="filter.status"
                         :placeholder="$t('all')"
                         size="mini">
                <el-option :label="$t('all')" value=""></el-option>
                <el-option
                  :label="$t('draft')"
                  :value="SPECIAL_OFFER_STATUS.DRAFT">
                </el-option>
                <el-option
                  :label="$t('published')"
                  :value="SPECIAL_OFFER_STATUS.PUBLISHED">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="padding: 10px 0;">
            <el-col :span="8" style="padding: 0 5px;">
              <label class="label-form-search">{{$t('market')}}</label>
            </el-col>
            <el-col :span="12" style="padding: 0 5px;">
              <el-select v-model="filter.marketId"
                         :placeholder="$t('all')"
                         size="mini"
                         filterable>
                <el-option :label="$t('all')" value=""></el-option>
                <el-option
                  v-for="(market, index) in sortedMarketList"
                  :key="index"
                  :label="market.name"
                  :value="market.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="padding: 10px 0;">
            <el-col :span="8" style="padding: 0 5px;">
              <label class="label-form-search">{{$t('salePerson')}}</label>
            </el-col>
            <el-col :span="12" style="padding: 0 5px;">
              <el-select v-model="filter.salePersonId"
                         :placeholder="$t('all')"
                         size="mini"
                         filterable>
                <el-option :label="$t('all')" value=""></el-option>
                <el-option
                  v-for="(salePerson, index) in sortedSalePersonList"
                  :key="index"
                  :label="`${salePerson.firstName} ${salePerson.lastName}`"
                  :value="salePerson.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="padding: 10px 0;">
            <el-col :span="8" style="padding: 0 5px;">
              <label class="label-form-search">{{$t('validBookingDate')}}</label><br>
            </el-col>
            <el-col :span="12" style="padding: 0 5px;">
              <el-date-picker v-model="filter.validBookingDate" style="width: 100% !important;"
                              type="date"
                              format="d MMM yyyy"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('selectDate')"
                              size="mini">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row style="padding: 10px 0;">
            <el-col :span="8" style="padding: 0 5px;">
              <label class="label-form-search">{{$t('periodOfIssueDate')}}</label><br>
            </el-col>
            <el-col :span="6" style="padding: 0 5px;">
              <el-date-picker v-model="filter.issueStartDate"
                              type="date"
                              format="d MMM yyyy"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('startDate')"
                              size="mini"
                              style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="6" style="padding: 0 5px;">
              <el-date-picker v-model="filter.issueEndDate"
                              type="date"
                              format="d MMM yyyy"
                              value-format="yyyy-MM-dd"
                              :placeholder="$t('endDate')"
                              size="mini"
                              style="width: 100%;">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="el-select el-select--mini"
               style="margin-top: 23px;"
               slot="reference"
               >
            <div class="el-input el-input--mini el-input--suffix">
              <input type="text"
                     readonly="readonly"
                     autocomplete="off"
                     :value="bindMoreFilter()"
                     :placeholder="$t('moreFilter')"
                     style="color: #409eff"
                     class="el-input__inner">
              <span class="el-input__suffix">
                <span class="el-input__suffix-inner">
                  <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{'is-reverse': visible}"></i>
                </span>
              </span>
            </div>
          </div>
        </el-popover>
      </el-col>
      <el-col :span="5" style="text-align: right;">
        <br />
        <el-button-group size="mini">
          <el-button type="primary"
                     size="mini"
                     @click="onSearchButtonClick">
            {{ $t('search') }}
          </el-button>
          <el-button type="info"
                     size="mini"
                     @click="onResetButtonClick">
            {{ $t('reset') }}
          </el-button>
        </el-button-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { SPECIAL_OFFER_STATUS, VUEX_EVENT } from '@/configs/constant'
import i18nMessages from '@/translations/SpecialOffer/components/SpecialOfferSearchComponent.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import { mapState } from 'vuex'

export default {
  name: 'SpecialOfferSearchComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  i18n: { messages: i18nMessages },
  props: {
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    promotionList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    },
    salePersonList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapState({
      specialOfferSearchCriteria: state => state.specialOffer.specialOfferSearchCriteria
    }),
    preparePromotionList: function () {
      if (this.filter.hotelId === '') {
        return []
      }

      const hotelPromotionList = this.promotionList.filter(promotion => (promotion.hotelId === this.filter.hotelId))
      const sortedHotelPromotionList = hotelPromotionList.sort((a, b) => {
        return (a.code.toLowerCase() > b.code.toLowerCase()) ? 1 : -1
      })

      return sortedHotelPromotionList
    }
  },
  created: function () {
    this.sortedHotelList = this.hotelList.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
    this.sortedAgentList = this.agentList.sort((a, b) => {
      return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
    })
    this.sortedSalePersonList = this.salePersonList.sort((a, b) => {
      return (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? 1 : -1
    })
    this.sortedMarketList = this.marketList.sort((a, b) => {
      return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
    })
    this.marketListById = this._prepareMarketListById()
    this.filter = Object.assign(this.filter, this.specialOfferSearchCriteria)
  },
  data () {
    return {
      SPECIAL_OFFER_STATUS,
      filter: {
        refCode: '',
        agentId: '',
        hotelId: '',
        promotionId: '',
        specialOfferValid: '',
        agentIdList: [],
        salePersonId: '',
        validBookingDate: '',
        issueStartDate: '',
        issueEndDate: '',
        marketId: '',
        status: ''
      },
      sortedHotelList: [],
      sortedAgentList: [],
      sortedPromotionList: [],
      sortedMarketList: [],
      sortedSalePersonList: [],
      marketListById: {},
      visible: false
    }
  },
  methods: {
    onHotelSelectChanged: function () {
      this.filter.promotionId = ''
    },
    onSearchButtonClick: async function () {
      this.filter.agentIdList = []

      if (this.filter.marketId !== '') {
        const market = this.marketList.find((item) => {
          return item.id === this.filter.marketId
        })

        this.filter.agentIdList = [...market.agentIdList]
      }

      if (this.filter.specialOfferValid === null) {
        this.filter.specialOfferValid = ''
      }

      if (this.filter.validBookingDate === null) {
        this.filter.validBookingDate = ''
      }

      if (this.filter.issueStartDate === null) {
        this.filter.issueStartDate = ''
      }

      if (this.filter.issueEndDate === null) {
        this.filter.issueEndDate = ''
      }

      this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.SET_SPECIAL_OFFER_SEARCH_CRITERIA, this.filter)
      this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.SET_SPECIAL_OFFER_LIST_CURRENT_PAGE, 1)
      this.$emit('onSearchButtonClick', this.filter)
    },
    onResetButtonClick: async function () {
      this._resetFilter()

      this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.SET_SPECIAL_OFFER_SEARCH_CRITERIA, this.filter)
      this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.SET_SPECIAL_OFFER_LIST_CURRENT_PAGE, 1)
      this.$emit('onResetButtonClick', this.filter)
    },
    bindMoreFilter: function () {
      const moreFilterText = this.$t('moreFilter')
      const numberOfMoreFilter = this.getNumberOfMoreFilter()
      if (numberOfMoreFilter > 0) {
        return `${moreFilterText} (${numberOfMoreFilter})`
      }

      return ''
    },
    getNumberOfMoreFilter: function () {
      let moreFilter = 0
      if (this.filter.status !== '') {
        moreFilter += 1
      }
      if (this.filter.marketId !== '') {
        moreFilter += 1
      }
      if (this.filter.salePersonId !== '') {
        moreFilter += 1
      }
      if (this.filter.validBookingDate !== '' && this.filter.validBookingDate !== null) {
        moreFilter += 1
      }
      if (this.filter.issueStartDate !== '' && this.filter.issueStartDate !== null) {
        moreFilter += 1
      }
      if (this.filter.issueEndDate !== '' && this.filter.issueEndDate !== null) {
        moreFilter += 1
      }
      return moreFilter
    },
    _resetFilter: function () {
      this.filter.refCode = ''
      this.filter.agentId = ''
      this.filter.hotelId = ''
      this.filter.promotionId = ''
      this.filter.specialOfferValid = ''
      this.filter.salePersonId = ''
      this.filter.validBookingDate = ''
      this.filter.status = ''
      this.filter.agentIdList = []
      this.filter.marketId = ''
      this.filter.issueStartDate = ''
      this.filter.issueEndDate = ''
    },
    _prepareMarketListById: function () {
      const marketListById = {}
      for (let market of this.marketList) {
        const id = market.id
        marketListById[id] = market
      }

      return marketListById
    }
  }
}
</script>

<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 177px;
  }
  .el-select {
    width: 100%;
  }
  .label-form-search {
    font-size: 13px;
    font-weight: 100;
  }
  #search-box{
    margin: 20px 0;
    padding: 15px 20px;
    background: #eeeeee;
    border: solid 1px #d8d6d6;
    border-radius: 5px;
  }
</style>
